<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-12 col-md-6">
          <h2>Calls Analysis</h2>
        </div>
        <div class="col-12 col-md-6">
          <div class="rating-container float-md-right mb-3">
            <RateCapability :qAppId="qAppIdRatingValue"></RateCapability>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 col-md-2">
            <div class="q-filter" id="pnwpKD"></div>
        </div>
        <div class="col-12 col-md-2">
            <div class="q-filter" id="AbsKjzp"></div>
        </div>
        <div class="col-12 col-md-2">
            <div class="q-filter" id="ucyJ"></div>
        </div>
        <div class="col-12 col-md-6">
          <h4>View As: </h4>
            <div class="q-filter flt3" id="fuHHPX"></div>
        </div>
      </div>

      <div class="row mb-5">
        <div class="col-12 col-sm-6 col-md-6">
            <div class="q-filter flt3" id="HjJmW"></div>
        </div>
        <div class="col-12 col-md-2">
            <div class="q-filter" id="yrgQ"></div>
        </div>
        <div class="col-12 col-md-2">
            <div class="q-filter" id="LBGLxU"></div>
        </div>
        <div class="col-12 col-md-2">
            <div class="q-filter" id="WSWm"></div>
        </div>
      </div>

      <div class="row mb-3" style="text-align: center">
        <div class="col-sm-12">
          <b>How many calls have been linked to opportunities?</b>
        </div>
      </div>

      <div class="row row-object one-viz-row mb-5">
        <div class="col-sm-12">
          <QlikViz vizId="svPkhNe" vizTitle="" />            
        </div>
      </div>

      <div class="row mb-3" style="text-align: center">
        <div class="col-sm-12">
          <b>What are the details for the selected opportunities?</b>
        </div>
      </div>

      <div class="row row-object one-viz-row mb-5">
        <div class="col-sm-12">
          <QlikViz vizId="JuXGmDC" vizTitle="" />            
        </div>
      </div>

      <div class="row mb-3" style="text-align: center">
        <div class="col-sm-12">
          <b>What are the details for logged calls for the selected opportunities?</b>
        </div>
      </div>

      <div class="row two-viz-row mb-4">
        <div class="col-12 col-lg-6 col-md-6 mb-3">
          <QlikViz vizId="mUmhN" vizTitle="" />
        </div>
        <div class="col-12 col-lg-6 col-md-6 mb-3">
          <QlikViz vizId="pxUCrmg" vizTitle="" />
        </div>
      </div>
    </div>
  </div>
</template>
<style>

</style>
<script>
import qAPI from "../../../services/qAPI";
import page from "../../../mixins/page";
import ToggleButtons from "../../../components/ToggleButtons"

export default {
  name: "CallsAnalysis",
  props: [],
  mixins: [page],
  components: {
      ToggleButtons
  },
  data() {
    return {
      pageName: this.$route.name,
      mashup: null,
      qObjects: "pnwpKD,AbsKjzp,ucyJ,fuHHPX,HjJmW,yrgQ,LBGLxU,WSWm,svPkhNe,JuXGmDC,mUmhN,pxUCrmg",
      qFilterObjects: [
        {
          id: "WcCBs",
          nFilters: 5,
        },
        {
          id: "rqmD",
          nFilters: 8,
        },
        {
          id: "rhypwjj",
          nFilters: 3,
        },
        {
          id: "mzZqgnE",
          nFilters: 2,
        },
        {
          id: "mRJrS",
          nFilters: 3,
        },
      ]
    };
  },
  async mounted() {
    await this.init(this.$route, this.qObjects, this.qFilterObjects);
  },
  async destroyed() {
    qAPI.closeQlikObjectsInStore(this.qObjects.split(","));
  },
  methods: {
    handleOptionSelected: function(option) {
      this.selectedOption = option;
    } 
  }  
};
</script>
